import React from 'react';
import { ArrowRight, Instagram, Youtube } from 'lucide-react';
import { Button } from './ui/button';
import { influencerData } from '../mock';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-[#0a0a0a] z-10" />
        <img
          src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438"
          alt="Fitness Training"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="inline-block mb-6 px-4 py-2 bg-[#00ff41]/10 border border-[#00ff41]/30 rounded-full">
          <span className="text-[#00ff41] font-semibold text-sm tracking-wider uppercase">
            {influencerData.tagline}
          </span>
        </div>

        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
          {influencerData.headline}
          <br />
          <span className="bg-gradient-to-r from-[#00ff41] to-[#ff6b35] bg-clip-text text-transparent">
            I Build Brands That Convert
          </span>
        </h1>

        <p className="text-xl sm:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto font-medium">
          {influencerData.subheadline}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Button
            onClick={scrollToContact}
            className="bg-[#00ff41] text-black hover:bg-[#00ff41]/90 font-bold text-lg px-8 py-6 group"
          >
            Let's Work Together
            <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
          </Button>
          <Button
            onClick={() => document.getElementById('content').scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-black font-bold text-lg px-8 py-6"
          >
            View My Content
          </Button>
        </div>

        {/* Social proof */}
        <div className="flex flex-wrap gap-6 justify-center items-center text-gray-400">
          <div className="flex items-center gap-2">
            <Instagram className="text-[#ff6b35]" size={24} />
            <span className="font-semibold">{influencerData.social.instagram}</span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-gray-600" />
          <div className="flex items-center gap-2">
            <Youtube className="text-[#ff6b35]" size={24} />
            <span className="font-semibold">{influencerData.social.youtube}</span>
          </div>
        </div>
      </div>

      {/* Gradient overlay at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" />
    </section>
  );
};

export default HeroSection;
